// extracted by mini-css-extract-plugin
export default {"rewardGift4ActivityC":"index_rewardGift4ActivityC__kM0vT"};